import { type CSSObject, Global } from "@emotion/react";
import type { FC } from "react";
import type { DeepPartial } from "react-hook-form";
import {
  type DividerSettings,
  type DividerTemplate,
} from "../email-design/types/email-divider-settings";

const dividerStyles = (dividerSetting?: DeepPartial<DividerTemplate>): CSSObject => ({
  border: 0,
  borderTopColor: dividerSetting?.color,
  borderTopStyle: dividerSetting?.style,
  borderTopWidth: dividerSetting?.width,
});

export const DividerStyles: FC<{
  dividers: DeepPartial<DividerSettings>;
  paper_colour?: string;
}> = ({ dividers, paper_colour }) => {
  return (
    <Global
      styles={{
        "hr.primary": dividerStyles(dividers.primary),
        "hr.secondary": dividerStyles(dividers.secondary),
        ".divider_button_paper_colour": {
          backgroundColor: paper_colour,
        },
      }}
    />
  );
};
